var cursor = null;
var isLoadingArticles = false;

$(document).ready(function () {
    loadArticles();
});

document.querySelector('#mizkan-dayori__show-more').addEventListener('click', function () {
    loadArticles();
});

async function loadArticles() {
    if (isLoadingArticles) return;
    isLoadingArticles = true;

    const loading = $('.comment-loading');
    loading.addClass('is-loading');
    const showMoreButton = document.querySelector('#mizkan-dayori__show-more');
    showMoreButton.setAttribute('hidden', true);

    try {
        const result = await fetch(`${window.AppProxyPath}/api/customers/mizkan-dayori/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                tags: [],
                cursor: cursor,
                limit: 8
            }),
        });

        const res = await result.json();
        if (res) {
            if (res.data.length) {
                cursor = res.data[res.data.length - 1].cursor;
                const placeholder = document.querySelector('.mizkan-dayori__articles-box').dataset.placeholder;
                for (const article of res.data) {
                    const new_article = $('.article_template .mizkan-dayori__article').clone();

                    new_article.attr('href', article.node.onlineStoreUrl);
                    const $img = $('.mizkan-dayori__article__img img', new_article);
                    if (article.node.image) {
                        $img.attr('src', article.node.image.url).attr('alt', article.node.title);
                    } else {
                        $img.attr('src', placeholder).attr('alt', 'NoImage');
                    }

                    $('.mizkan-dayori__article__new', new_article)
                        .addClass('mizkan-dayori-content-new-icon')
                        .attr({
                            'data-id': article.node.id.replace('gid://shopify/Article/', ''),
                            'data-published_at': article.node.publishedAt,
                            'hidden': true
                        });

                    $('.mizkan-dayori__article__title', new_article).text(ellipsis(article.node.title, 30));
                    $('.mizkan-dayori__article__date', new_article)
                        .attr('datetime', formatDate(article.node.publishedAt, '-'))
                        .text(formatDate(article.node.publishedAt, '.'));

                    $('.mizkan-dayori__article__likes', new_article)
                        .attr('data-article-id', article.node.id.replace('gid://shopify/Article/', ''));

                    const commentNumber = article.node.comments?.totalCount || 0;
                    $('.mizkan-dayori__article__count span', new_article).text(formatCountText(commentNumber));

                    $('.mizkan-dayori__articles-box').append(new_article);
                }

                // NEW表示は未ログインでは customers-content-history.js が読み込まれず
                // checkNewMizkanDayoriContents が未定義になる。ここで失敗しても
                // いいね数の反映と「もっと見る」の表示を止めないよう独立させる
                try {
                    const unReadContentsObj = JSON.parse(localStorage.getItem('unReadContents'));
                    if (unReadContentsObj && typeof checkNewMizkanDayoriContents === 'function') {
                        checkNewMizkanDayoriContents(unReadContentsObj);
                    }
                } catch (error) {
                    console.error('Failed to apply NEW icons:', error);
                }

                // 追加した記事のいいね数をまとめて取得して反映（awaitしない: 記事表示をブロックしないため）
                applyLikeCounts(res.data.map(article => article.node.id.replace('gid://shopify/Article/', '')));
            }
            if (res.hasNextPage) {
                showMoreButton.removeAttribute('hidden');
            }
        }
    } catch (error) {
        console.error('Failed to load articles:', error);
    } finally {
        loading.removeClass('is-loading');
        isLoadingArticles = false;
    }
}

// いいね数集計APIでまとめて取得し、該当カードに反映する
async function applyLikeCounts(articleIds) {
    if (!articleIds.length) return;
    try {
        const result = await fetch(`${window.AppProxyPath}/api/customers/mizkan-dayori/like-counts?article_ids=${articleIds.join(',')}`);
        const res = await result.json();
        if (!res.counts) return;
        for (const [articleId, count] of Object.entries(res.counts)) {
            $(`.mizkan-dayori__articles-box .mizkan-dayori__article__likes[data-article-id="${articleId}"] span`).text(formatCountText(count));
        }
    } catch (error) {
        console.error('Failed to load like counts:', error);
    }
}

function ellipsis(str, len) {
    return str.length > len ? str.substring(0, len) + '...' : str;
}

function formatDate(date, separator) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join(separator);
}

function formatCountText(count) {
    var n = Number(count) || 0;
    return n >= 10000 ? '9999+' : String(n);
}
